<div class="row">
  <div class="col-md-9">
    <h3 class="search-result-title"><a (click)="openResult()">{{ result.title }}</a></h3>
    <div class="row">
      <div class="col-md-7">
        <div class="provider-image-mobile">
          <a (click)="openResult()"><img class="search-result-image"
              src="https://www.wakehealth.edu/{{ result.image }}" /></a>
        </div>
        <div *ngIf="result.specialties?.length" class="search-result-specialties">
          <h4 class="specialties-title search-result-subtitle">Specialties</h4>
          <ul class="search-result-specialities">
            <li *ngFor="let specialty of result.specialties">
              {{ specialty }}
            </li>
          </ul>
        </div>
        <div>{{ result.position }}</div>
        <div>{{ result.providerType }}</div>
        <div class="search-result-rating" *ngIf="result.showRating && result.totalRatings > 0">
          <div class="stars-base">
            <i class="fa fa-star-o"></i>
            <i class="fa fa-star-o"></i>
            <i class="fa fa-star-o"></i>
            <i class="fa fa-star-o"></i>
            <i class="fa fa-star-o"></i>
          </div>
          <div class="stars-value" [ngStyle]="{ 'width': getRatingPercentage() }">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
        </div>
        <a (click)="openResult()" *ngIf="result.showRating && result.totalRatings > 0">{{ result.rating }} ({{ result.totalRatings }} ratings)</a>

        <div *ngIf="!result.showRating">
          <div class="search-result-rating">
            <div class="stars-base">
              <i class="fa fa-star-o"></i>
              <i class="fa fa-star-o"></i>
              <i class="fa fa-star-o"></i>
              <i class="fa fa-star-o"></i>
              <i class="fa fa-star-o"></i>
            </div>    
          </div>
          <a class="no-ratings" (click)="noRatingClick()">Why no ratings?</a>
          <div *ngIf="showNoRatingDialog" class="dialog-content">
            <div class="norating-dialog">
              <a class="dialog-close" (click)="noRatingDialogClose()">
                <span class="sr-only">Close no ratings dialog</span> <i class="fa fa-remove"></i>
              </a>
              <div class="h3">Why No Ratings</div>
              <p>Currently, not all doctor ratings and comments are available. The number of rated physicians will increase over time.</p>
              <p>The more ratings a provider receives, the more accurate and statistically reliable the data is. Providers with less than 30 ratings may not have patient ratings listed on their profiles.</p>
              <p>To learn more about this survey process, visit our <a href="/About-Us/Quality-and-Awards/Quality-and-Safety-Measures/Patient-Experience/About-the-Press-Ganey-Patient-Experience-Survey">about the survey page</a>.</p>
            </div>
          </div>
        </div>
        <div *ngIf="showNoRatingDialog" class="dialog-backdrop"></div>
        <a data-toggle="modal" class="insurance-accepted" data-target="#providerInsuranceModal">Insurance Accepted</a>
        <div *ngIf="result.newpatients === 'true'" class="accepting-new-patients">Accepting New Patients</div>
        <div *ngIf="result.onlineSchedule === 'true' && result.newpatients === 'true'" style="margin-top: 20px;" class="hidden-xs">
          <a class="btn schedule-button" data-toggle="modal" data-target="#schedApptOptionsModal" title="Appointments" [attr.data-pn-name]="result.fullName" [attr.data-pn-id]="result.epicId" [attr.data-m-path]="result.messagePath" [attr.data-pn-ds]="result.directSchedule" [attr.data-pn-ap]="result.newpatients" [attr.data-pn-ep]="result.existingpatients" [attr.data-pn-os]="result.onlineSchedule" [attr.data-pn-vt]="(result.visitType ? result.visitType : '1003')" [attr.data-pn-url]="result.uri">Appointments</a>
        </div>
      </div>
      <div class="col-md-5">
        <ng-container *ngIf="result.locations.length">
          <h3 class="search-result-locations-title search-result-subtitle">
            Locations
          </h3>
          <div *ngFor="let location of result.locations" class="result-location">
            <h4 class="location-title"><a
                href="{{location.pageurl}}">{{ location.name }}</a></h4>
            <div>{{ location.address1 }}</div>
            <div *ngIf="location.floorsuite">{{ location.floorsuite }}</div>
            <div>{{ location.address2 }}</div>
            <div *ngIf="location.distance" class="location-distance">Distance from location:
              {{ (location.distance/1610).toFixed(2) }} miles</div>
            <div *ngIf="location.phone" class="location-phone"><a
                href="tel:{{ location.phone }}">{{ location.phone }}</a></div>

          </div>
        </ng-container>
        <div *ngIf="result.onlineSchedule === 'true' && result.newpatients === 'true'" style="margin-top: 20px;" class="visible-xs-block">
          <a class="btn schedule-button" data-toggle="modal" data-target="#schedApptOptionsModal" title="Options" [attr.data-pn-name]="result.fullName" [attr.data-pn-id]="result.epicId" [attr.data-m-path]="result.messagePath" [attr.data-pn-ds]="result.directSchedule" [attr.data-pn-ap]="result.newpatients" [attr.data-pn-ep]="result.existingpatients" [attr.data-pn-os]="result.onlineSchedule" [attr.data-pn-vt]="(result.visitType ? result.visitType : '1003')" [attr.data-pn-url]="result.uri">Appointments</a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-3 text-right provider-image-desktop">
    <a (click)="openResult()"><img class="search-result-image"
        src="https://www.wakehealth.edu/{{ result.image }}" /></a>
  </div>
</div>

